/* eslint-disable */
export const getMapSize = (x) => {
    var len = 0;
    for (var _ in x) {
        len++;
    }

    return len;
}
/* eslint-enable */


export const getPackProgress = (pack, scores) => {
    const packLessons = pack.lessons
    let packProgress = 0;

    let maxI = 0;
    for (let i = 0; i < packLessons.length; i++) {
        let packLesson = packLessons[i];
        if (scores[packLesson.id]) {
            const packLessonScores = scores[packLesson.id]
            let count = 0

            for (let stageIndex of Object.keys(packLessonScores)) {
                if (packLesson.stages.includes(stageIndex)) {
                    count += 1
                }
            }

            if (count === packLesson.stages.length) {
                packProgress += 1
                maxI = i + 1
            }
            else {
                maxI = i;
            }

        }
    }

    return [packProgress, maxI]
}

export const STAGES_DB_BY_KEY = {
    '1': 'vocabularies',
    '2': 'practices',
    '3': 'studies',
    '4': 'dialogues',
    '5': 'texts',
    '6': 'listens',
    '7': 'quizes',
    '8': 'alphabets',
}


export function shuffledArray(a) {
    const newA = a.slice()
    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newA[i], newA[j]] = [newA[j], newA[i]];
    }
    return newA;
}
